import type { CollectionEntry } from 'astro:content';

export function filterByText(
  entries: CollectionEntry<'learn'>[],
  text?: string,
) {
  if (!text) {
    return entries;
  }

  const searchKey = text.toLowerCase();
  const seenEntries = new Set<CollectionEntry<'learn'>>();
  const topicMatches: CollectionEntry<'learn'>[] = [];
  const descriptionMatches: CollectionEntry<'learn'>[] = [];

  entries.forEach((entry) => {
    if (entry.data.topic?.toLowerCase().includes(searchKey)) {
      topicMatches.push(entry);
      seenEntries.add(entry);
    } else if (
      entry.data.description?.toLowerCase().includes(searchKey) &&
      !seenEntries.has(entry)
    ) {
      descriptionMatches.push(entry);
    }
  });

  return [...topicMatches, ...descriptionMatches];
}
